// Labeled horizontal bars; rows is [[label, count, note?], ...]
export default function Breakdown({ title, rows }) {
  const max = Math.max(1, ...rows.map(([, count]) => count));

  return (
    <section className="adm-breakdown" aria-label={title}>
      <h2>{title}</h2>
      {rows.length === 0 ? (
        <p className="adm-muted">No campers yet.</p>
      ) : (
        <table>
          <tbody>
            {rows.map(([label, count, note]) => (
              <tr key={label}>
                <th scope="row">
                  {label}
                  {note && <span className="adm-muted"> {note}</span>}
                </th>
                <td className="adm-breakdown__bar" aria-hidden="true">
                  <span style={{ width: `${(count / max) * 100}%` }} />
                </td>
                <td className="adm-breakdown__count">{count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
